import { PenIcon } from "../assets/icons/PenIcon";
import {ProgressWithContentCircle} from "../pages/StudentBoard/StudentBoard.type";

export type LessonType = {
  id: string,
  _id: string,
  active: boolean,
  order: number,
  lesson_type: string,
  status: string,
  // activities:
};

// const ActivityIcons = {
//   PICTURE_IMAGE: <PenIcon/>,
// }

export type LessonsType = ProgressWithContentCircle[];
//
// export const LESSONS = [{
//   isUnlocked: true,
//   iconPath: "/images/topics/greeting.png",
//   redirectPath: "topic/greeting-unit/words",
//   // type: ActivityIcons.PICTURE_IMAGE
// }, {
//   isUnlocked: true,
//   iconPath: "/images/topics/animals.png",
//   redirectPath: "topic/animals-unit"
// }, {
//   isUnlocked: true,
//   iconPath: "/images/topics/nature.png",
//   redirectPath: "topic/nature-unit"
// }, {
//   isUnlocked: false,
//   iconPath: "/images/topics/daily-routing.png",
//   redirectPath: "topic/daily-routine-unit"
// }, {
//   isUnlocked: false,
//   iconPath: "/images/topics/everyday-items.png",
//   redirectPath: "topic/greeting-unit"
// }]


export const LESSONS = [
  {
    "_id": "69772bdfc8cd00f681f7a8d4",
    "activities": [
      {
        "_id": "69772bdfc8cd00f681f7a8d5",
        "id": "696a66c07bbf3e4de4b8dc5a",
        "status": "none",
        "active": true,
        "order": 1,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d6",
        "id": "696a8f0d7bbf3e4de4b8dc82",
        "status": "none",
        "active": true,
        "order": 2,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d7",
        "id": "696a905b7bbf3e4de4b8dc93",
        "status": "none",
        "active": true,
        "order": 3,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d8",
        "id": "696a90e37bbf3e4de4b8dc98",
        "status": "none",
        "active": true,
        "order": 4,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d9",
        "id": "696a92027bbf3e4de4b8dca9",
        "status": "none",
        "active": true,
        "order": 5,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8da",
        "id": "696a926c7bbf3e4de4b8dcac",
        "status": "none",
        "active": true,
        "order": 6,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8db",
        "id": "696a92bc7bbf3e4de4b8dcb0",
        "status": "none",
        "active": true,
        "order": 7,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8dc",
        "id": "696a930b7bbf3e4de4b8dcb3",
        "status": "none",
        "active": true,
        "order": 8,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8dd",
        "id": "696a93667bbf3e4de4b8dcb6",
        "status": "none",
        "active": true,
        "order": 9,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8de",
        "id": "696a93af7bbf3e4de4b8dcb9",
        "status": "none",
        "active": true,
        "order": 10,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8df",
        "id": "696a94397bbf3e4de4b8dcbd",
        "status": "none",
        "active": true,
        "order": 11,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8e0",
        "id": "696a94977bbf3e4de4b8dcc0",
        "status": "none",
        "active": true,
        "order": 12,
      }
    ],
    "id": "6957f1ce1d0de0a1808843cb",
    "status": "success",
    "active": true,
    "order": 1,
    "lesson_type": "learn",
    "activity_type": "listen",
  },
  {
    "_id": "69772bdfc8cd00f681f7a8e1",
    "id": "6957f14d1d0de0a1808843bb",
    "status": "none",
    "activities": [
      {
        "_id": "69772bdfc8cd00f681f7a8d5",
        "id": "696a66c07bbf3e4de4b8dc5a",
        "status": "none",
        "active": true,
        "order": 1,
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d6",
        "id": "696a8f0d7bbf3e4de4b8dc82",
        "status": "none",
        "active": true,
        "order": 2,
      },
    ],
    "active": true,
    "order": 2,
    "lesson_type": "practice",
    "activity_type": "ChooseImage",
  },
  {
    "_id": "69772bdfc8cd00f681f7a8e2",
    "id": "696e62bc263524c2a420b84e",
    "status": "none",
    "activities": [
      {
        "_id": "69772bdfc8cd00f681f7a8d5",
        "id": "696a66c07bbf3e4de4b8dc5a",
        "status": "none",
        "active": true,
        "order": 1
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d6",
        "id": "696a8f0d7bbf3e4de4b8dc82",
        "status": "none",
        "active": true,
        "order": 2
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d7",
        "id": "696a905b7bbf3e4de4b8dc93",
        "status": "none",
        "active": true,
        "order": 3
      },
      {
        "_id": "69772bdfc8cd00f681f7a8d8",
        "id": "696a90e37bbf3e4de4b8dc98",
        "status": "none",
        "active": true,
        "order": 4
      },
    ],
    "active": true,
    "order": 3,
    "lesson_type": "story",
    "activity_type": "ChooseImage",
  }
]
